import { SVGProps } from 'react';

const IconPhoneBold = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="30"
      height="28"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2674 15.0014L12.5 12.9749C14.3794 11.4934 14.1666 11.5001 16.3146 12.8511L16.5208 12.9749C16.7275 13.0989 16.9047 13.2664 17.0402 13.4657C17.556 14.2246 17.3589 15.258 16.5999 15.7738L15.5765 16.4694C14.8235 16.9812 13.8614 17.0734 13.0249 16.714C10.9039 15.8027 8.68574 14.2576 6.37046 12.0787C4.01023 9.85738 2.42422 7.62152 1.61245 5.37108C1.3226 4.56755 1.43523 3.6738 1.91538 2.96731L2.67529 1.84918C2.81076 1.64984 2.98798 1.48237 3.19464 1.35837C3.98151 0.886248 5.00212 1.1414 5.47424 1.92827L5.598 2.13453C6.66663 4.00006 6.66663 4.00006 5.83329 5.25006L3.44775 8.18171"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M18.0784 7.23158C17.1393 4.72011 15.1493 2.72146 12.6436 1.77075"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        d="M15.2385 8.41663C14.5665 6.61205 13.1353 5.17706 11.3333 4.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default IconPhoneBold;
